import { render } from "./glassitem-properties.vue?vue&type=template&id=d849e47a"
import script from "./glassitem-properties.vue?vue&type=script&lang=js"
export * from "./glassitem-properties.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__